"use client";

import * as React from "react";
import { cn } from "@/lib/utils";

export interface UnderlineInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  error?: boolean;
}

const UnderlineInput = React.forwardRef<HTMLInputElement, UnderlineInputProps>(
  ({ className, icon, error, ...props }, ref) => (
    <div className="w-full">
      <div
        className={cn(
          "flex items-center gap-2 border-b bg-transparent py-2 transition-colors",
          error
            ? "border-[var(--iris-red)]"
            : "border-[#2A2A2A] focus-within:border-white"
        )}
      >
        {icon && (
          <span className="flex shrink-0 text-[var(--iris-text-muted)]">
            {icon}
          </span>
        )}
        <input
          ref={ref}
          className={cn(
            "min-w-0 flex-1 bg-transparent text-sm text-white placeholder:text-[#555555] focus:outline-none",
            className
          )}
          {...props}
        />
      </div>
    </div>
  )
);
UnderlineInput.displayName = "UnderlineInput";

export { UnderlineInput };
